import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import {
  ClaimCycleProfessionalSubscriptionReportLineContainerModel
} from '../../../../../../models';


@Injectable({
  providedIn: 'root'
})
export class ClaimCycleProfessionalSubscriptionReportLineService extends BaseApiTemplateService<ClaimCycleProfessionalSubscriptionReportLineContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/professional-subscription-report-lines/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/professional-subscription-report-lines/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/professional-subscription-report-lines/backoffice-ep';

    this.httpClient = http;
  }

  generateProfessionalSubscriptionReportLines(claimCycleGuid: any, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/professional-subscription-report-lines/generation/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/professional-subscription-report-lines/generation/backoffice-ep';
    }

    return this.httpClient.post(url, claimCycleGuid, this.getHttpHeader(visa));
  }

  exportProfessionalSubscriptionReport(lines: any[], visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/professional-subscription-report-lines/export/xlsx/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/professional-subscription-report-lines/export/xlsx/backoffice-ep';
    }
    return this.httpClient.post<Blob>(url, lines,  this.getHttpHeaderBlob(visa));
  }

}
